<template>
    <div class="container remove-padding-margin">
        <main class="add-padding-default">
            <div class="fixed-judul fixed-top">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding-margin">
                        <img @click="back" src="../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center">
                        <h6 class="remove-margin">Lupa Kata Sandi</h6>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">

                    </div>
                </div>
            </div>

            <div class="conten-2 flex-100">
                <div class="flex-1">
                    <div class="text-outlet">
                        <div class="set-text">Silahkan masukkan <b>email</b> Anda, kami akan mengirim link untuk melakukan <b>reset kata
                            sandi.</b></div>
                    </div>
                    <form class="remove-padding" action="">
                        <div class="form-group">
                            <label for="input-1">Email</label>
                            <input class="form-control" placeholder="email@gmail.com" type="email" v-on:keyup="validateEmailInput" v-model="email" id="input-1"/>
	                        <ErrorMessage class="error" label="Email" :validation="$v.email"></ErrorMessage>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long" @click="sendEmail" id="btnSend">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span>
                        <span id="textBtn">Kirim Sekarang</span>
                    </button>
					<!--<button type="button" class="btn btn-outline-primary btn-long" @click="gologin">-->
					<!--    <span id="textBtn2">Kembali ke Login</span>-->
					<!--</button>-->
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {email, required} from "vuelidate/lib/validators";

    export default {
        name: "ForgotPassword",
        mounted() {
            // var floatlabels = new FloatLabels('form', {
            //     style: 2
            // });
           this.type=parseInt(this.$route.params.type)
        },
	    components: { ErrorMessage },
        data() {
            return {
                email: "",
                isClicked: false,
                type:'',
            }
        },
	    validations: {
        	email: {
        		required,
		        email,
	        }
	    },
        methods: {
            gologin() {
                this.$router.push('/login')
            },

            back() {
                if(this.type===0){
                    this.$router.push('/login#nav-email')
                }else if(this.type===1){
                    this.$router.push('/editemail')
                }else if(this.type===2){
                    this.$router.push('/loginowneremail')

                }

            },

            validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            validateEmailInput(event) {
            	return
                var emailData = this.email;
                if (this.validateEmail(emailData)) {
                    $('#btnSend').prop('disabled', false);
                } else {
                    $('#btnSend').prop('disabled', true);
                }
            },
            async sendEmail() {
	            if (this.$v.email.$invalid) {
		            this.$v.email.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return true
	            }
                $('#btnSend').prop('disabled', true);
                this.isClicked = true;
                $('#textBtn').hide();
                var emailForgot = this.email;
                try {
                    const dataUser = new FormData;
                    dataUser.append('email', emailForgot);
                    // const res = await this.$axios.post(this.$baseurl + '/auth/forgot_password', dataUser)
	                const res = await this.$axios.post(this.$baseurl + '/auth/send_email_forgot_password', dataUser)
                        if (res.data.status === true){
                        	localStorage.setItem("forgot_password", emailForgot)
                            $('#btnSend').html('Cek Email Anda');
                            this.$toast.success(res.data.msg)
                            // this.$router.push('/ResetPassword')
                            localStorage.setItem("email", emailForgot);
                        }else{
                            this.$toast.error(res.data.msg)
                            this.isClicked = false
                            $('#textBtn').show();
                            $('#btnSend').prop('disabled', false);
                            this.validateEmailInput()
                        }
                } catch (e) {
                	this.$catch_error_response(e)
	
	                this.isClicked = false
	                $('#textBtn').show();
	                $('#btnSend').prop('disabled', false);
	                this.validateEmailInput()
                }
            },
        }
    }
</script>

<style scoped>
    .button-lanjut {
        margin-bottom: 10px;
    }

    .set-text{
        font-weight: normal;
        font-size: 14px;
        line-height: 140%;
        align-items: center;
        letter-spacing: -0.02em;
        color: #333333;

    }
</style>